import {flagPathByCountryCode} from '@hconnect/uikit'
import {LabelRegular, TextMedium} from '@hm/fundamental'
import React from 'react'

type CountryDataScopeProps = {
  countryId?: string
}

export const CountryDataScope = ({countryId}: CountryDataScopeProps) => {
  const countriesData = window.intlTelInputGlobals.getCountryData()
  const shouldDisplayFlag = !!countryId && countryId !== '*' && countryId !== 'MOCK'
  const formattedCountryName = () => {
    if (countryId === 'MOCK') {
      return 'MOCK'
    }

    if (countryId === '*') {
      return 'ALL'
    }
    return countriesData.find((countryData) => countryData.iso2.toUpperCase() === countryId)?.name
  }

  return (
    <div className="flex flex-col px-3">
      <LabelRegular className="text-foreground_faded mt-0.5">Country</LabelRegular>
      <div className={`flex gap-1 items-center px-${shouldDisplayFlag ? 0.5 : 0}`}>
        {shouldDisplayFlag && (
          <img
            src={flagPathByCountryCode(countryId)}
            alt={`${countryId}-flag`}
            className="max-h-[16px]"
          />
        )}
        <TextMedium className="text-foreground">{formattedCountryName()}</TextMedium>
      </div>
    </div>
  )
}
